import { render } from "./BulkUpdateModal.vue?vue&type=template&id=08c69eaf"
import script from "./BulkUpdateModal.vue?vue&type=script&lang=js"
export * from "./BulkUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__